import { RefObject, useEffect } from 'react'

export const useClickOutside = <T extends HTMLElement = HTMLElement>(ref: RefObject<T | null>, handler: (event: Event) => void) => {
    useEffect(() => {
        const listener = (event: Event) => {
            const el = ref.current
            const target = event.target as Node | null
            if (!el || el.contains(target)) return
            handler(event)
        }

        document.addEventListener('pointerdown', listener)

        return () => {
            document.removeEventListener('pointerdown', listener)
        }
    }, [ref, handler])
}
